var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z"}}),(_vm.title !== '')?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }